import React from 'react';
import PropTypes from 'prop-types';

function AccountNameCell({ dataItem }) {
  return (
    <td>
      <a href={dataItem.path}>{dataItem.name}</a>
    </td>
  );
}

AccountNameCell.propTypes = {
  dataItem: PropTypes.shape({
    path: PropTypes.string,
    name: PropTypes.string
  }).isRequired
};

export default AccountNameCell;
